import { useEffect } from "react";
import { useGetSettingsQuery } from "@/app/settingsApi";
import { reactPlugin } from "@/config";

export function useAppInsights() {
  const { data: settings } = useGetSettingsQuery();

  useEffect(() => {
    if (settings?.appInsightsConnectionString) {
      (async () => {
        const { ApplicationInsights } = await import(
          "@microsoft/applicationinsights-web"
        );
        const appInsights = new ApplicationInsights({
          config: {
            connectionString: settings?.appInsightsConnectionString,
            enableAutoRouteTracking: true,
            extensions: [reactPlugin],
          },
        });
        appInsights.loadAppInsights();
      })();
    }
  }, [settings]);
}
